const getVersionVueTable = (httpClient, filtering, sorting, paging, params) => {
  return httpClient
    .get(`update_info`, {
      params: {
        search: filtering ? filtering.query : null,
        fields: filtering ? filtering.fields.join() : null,
        sort: sorting ? sorting.by : null,
        order: sorting ? sorting.order : null,
        page: paging ? paging.page : null,
        limit: paging ? paging.perPage : null,
        ...params,
      },
    })
    .then((res) => res.data);
};

const getTagVueTable = (httpClient, filtering, sorting, paging, params) => {
  return httpClient
    .get(`update_tag`, {
      params: {
        search: filtering ? filtering.query : null,
        fields: filtering ? filtering.fields.join() : null,
        sort: sorting ? sorting.by : null,
        order: sorting ? sorting.order : null,
        page: paging ? paging.page : null,
        limit: paging ? paging.perPage : null,
        ...params,
      },
    })
    .then((res) => res.data);
};

const deleteVersion = (httpClient, id) => {
  return httpClient.delete(`update_info/${id}`).then((res) => res.data);
};

const addTag = (httpClient, tag) => {
  return httpClient.post(`update_tag`, tag).then((res) => res.data);
};

const updateTag = (httpClient, tag) => {
  return httpClient.patch(`update_tag/${tag._id}`, tag).then((res) => res.data);
};

const getOSVueTable = (httpClient, filtering, sorting, paging, params) => {
  return httpClient
    .get(`update_os`, {
      params: {
        search: filtering ? filtering.query : null,
        fields: filtering ? filtering.fields.join() : null,
        sort: sorting ? sorting.by : null,
        order: sorting ? sorting.order : null,
        page: paging ? paging.page : null,
        limit: paging ? paging.perPage : null,
        ...params,
      },
    })
    .then((res) => res.data);
};

const addOS = (httpClient, os) => {
  return httpClient.post(`update_os`, os).then((res) => res.data);
};

const getOSGroup = (httpClient) => {
  return httpClient.get(`update_os/group-os`).then((res) => res.data);
};

const updateOS = (httpClient, os) => {
  return httpClient.patch(`update_os/${os._id}`, os).then((res) => res.data);
};

const getRepoVueTable = (httpClient, filtering, sorting, paging, params) => {
  return httpClient
    .get(`update_repo`, {
      params: {
        search: filtering ? filtering.query : null,
        fields: filtering ? filtering.fields.join() : null,
        sort: sorting ? sorting.by : null,
        order: sorting ? sorting.order : null,
        page: paging ? paging.page : null,
        limit: paging ? paging.perPage : null,
        ...params,
      },
    })
    .then((res) => res.data);
};

const getOSList = (httpClient) => {
  return httpClient.get(`update_os/list`).then((res) => res.data);
};

const getActiveOSList = (httpClient) => {
  return httpClient.get(`update_os/list?status=true`).then((res) => res.data);
};

const deleteOS = (httpClient, id) => {
  return httpClient.delete(`update_os/${id}`).then((res) => res.data);
};

const addRepo = (httpClient, repo) => {
  return httpClient.post(`update_repo`, repo).then((res) => res.data);
};

const deleteRepo = (httpClient, id) => {
  return httpClient.delete(`update_repo/${id}`).then((res) => res.data);
};

const uploadRepoFile = (httpClient, form) => {
  return httpClient
    .post(`update_repo/file`, form, {
      headers: { "Content-Type": "multipart/form-data" },
      timeout: 600000,
    })
    .then((res) => res.data);
};

const uploadRepoFilePart = (httpClient, form, id, filename) => {
  return httpClient
    .post(`update_repo/file/${id}/part?filename=${filename}`, form, {
      headers: { "Content-Type": "multipart/form-data" },
      timeout: 600000,
    })
    .then((res) => res.data);
};

const uploadRepoFileComplete = (httpClient, form, id, filename) => {
  return httpClient
    .post(`update_repo/file/${id}/complete?filename=${filename}`, form, {
      headers: { "Content-Type": "multipart/form-data" },
      timeout: 600000,
    })
    .then((res) => res.data);
};

const downloadRepoFile = (httpClient, id) => {
  return httpClient.get(`update_repo/file/${id}`).then((res) => res.data);
};

const getTagList = (httpClient) => {
  return httpClient.get(`update_tag/list`).then((res) => res.data);
};

const updateVersion = (httpClient, version) => {
  return httpClient
    .patch(`update_info/${version._id}`, version)
    .then((res) => res.data);
};

const addVersion = (httpClient, version) => {
  return httpClient.post(`update_info`, version).then((res) => res.data);
};

const latestVersion = (httpClient, type) => {
  return httpClient.get(`update_info/${type}/latest`).then((res) => res.data);
};

const versionInfor = (httpClient, type, version) => {
  return httpClient
    .get(`update_info/${type}/${version}`)
    .then((res) => res.data);
};

const updateAgent = (httpClient, form) => {
  return httpClient
    .post(`update/agent`, form, {
      headers: { "Content-Type": "multipart/form-data" },
      timeout: 600000,
    })
    .then((res) => res.data);
};

const updateDb = (httpClient, form) => {
  return httpClient
    .post(`update/db`, form, {
      headers: { "Content-Type": "multipart/form-data" },
      timeout: 600000,
    })
    .then((res) => res.data);
};

const createVersionOffline = (httpClient, id) => {
  return httpClient.post(`update_info/${id}/offline`).then((res) => res.data);
};

const uploadVersionOffline = (httpClient, form) => {
  return httpClient
    .post(`update_info_v2/upload_file_offline`, form, {
      headers: { "Content-Type": "multipart/form-data" },
      timeout: 600000,
    })
    .then((res) => res.data);
};

const completeCreateVersion = (httpClient, form) => {
  return httpClient
    .patch(`update_repo/file/complete`, form)
    .then((res) => res.data);
};

const checkIsRoot = (httpClient) => {
  return httpClient.get(`product`).then((res) => res.data);
};

export default {
  updateAgent,
  updateDb,
  deleteVersion,
  getTagVueTable,
  addTag,
  getOSVueTable,
  addOS,
  getOSGroup,
  updateOS,
  updateTag,
  getRepoVueTable,
  getOSList,
  addRepo,
  deleteRepo,
  uploadRepoFile,
  uploadRepoFilePart,
  uploadRepoFileComplete,
  downloadRepoFile,
  getVersionVueTable,
  getTagList,
  updateVersion,
  addVersion,
  latestVersion,
  versionInfor,
  createVersionOffline,
  uploadVersionOffline,
  deleteOS,
  getActiveOSList,
  completeCreateVersion,
  checkIsRoot,
};
